<template>
<div>

	<form enctype="multipart/form-data"
	      novalidate
	      class="mb-4">

		<b-alert v-if="mediaError.errors"
		         show
		         variant="warning">
			<span v-for="errors in mediaError.errors">
  				<span v-for="error in errors">{{ error }}<br /></span>
			</span>
		</b-alert>

		<div class="dropbox"
		     v-bind:class="{ hovered: hoverDropbox }">
			<input type="file"
			       v-on:dragenter="dragEnter"
			       v-on:dragleave="dragLeave"
			       v-on:drop="dragLeave"
			       v-if="isUploading == false"
			       multiple
			       @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
			       accept="image/*"
			       class="input-file">

			<div class="dropbox-info"
			     v-if="uploadingFileCount < 1">
				Plaats uw bestanden hier om te beginnen
				<br /> of klik om te selecteren
			</div>

			<div class="row dropbox-info justify-content-center"
			     v-if="uploadingFileCount > 0">
				<div class="col-sm-12 col-md-6">
					<b-progress :value="uploadingStatus"
					            variant="info"
					            striped
					            animated
					            height="2rem"
					            class="mb-2"></b-progress>
					{{ fileCount - uploadingFileCount }} van {{ fileCount }} bestanden aan het uploaden...
				</div>

			</div>
		</div>
	</form>

	<div class="row media">
		<div v-for="(media, index) in item.media"
		     :key="index"
		     class="col col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-6 media-item">
			<figure class="media-item-image"
			        :style="{ backgroundImage: 'url(' + medium(media.url) + ')' }">
			        <!-- :style="`background-image: url(${media.url});`" -->
				<button type="button"
				        class="media-item-image-delete"
				        :hidden="isDeleting && deletingKey == index"
				        v-on:click="showDeleteModal({ itemId: item.id, mediaId: media.id, mediaKey: index })"><i class="fa fa-fw fa-trash"></i> Verwijder</button>
				<div class="media-item-image-loader"
				     v-if="isDeleting && deletingKey == index"><i class="fa fa-spinner fa-spin fa-3x fa-fw"></i></div>
			</figure>
		</div>
	</div>

	<delete-dialog-modal ref="deleteModal"
	                     :delete-name="$t('media.deleteModalMessage')"
	                     :item="selectedDeleteMedia"
	                     :isDeleting="isDeleting"
	                     @confirm="deleteMediaItem"></delete-dialog-modal>
</div>
</template>

<script>
import DeleteDialogModal from '@/components/elements/Edit/DeleteDialogModal';
import { flashSuccess, flashDanger } from '@/helpers/flash-message-helper';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers('item');

export default {
	components: {
		DeleteDialogModal
	},
	data() {
		return {
			hoverDropbox: false,
			deletingKey: false,
			uploadingStatus: 0,
			uploadingFileCount: 0,
			selectedDeleteMedia: null
		}
	},
	computed: {
		...mapGetters([
			'item',
			'isUploading',
			'mediaError',
			'isDeleting'
		])
	},
	methods: {
		...mapActions([
			'uploadMedia',
			'deleteMedia'
		]),
		medium(url){
			let chunk 		= url.split('/');
			let file_name 	= chunk[chunk.length - 1];
			let medium_name 	= 'medium_' + file_name;

			return url.replace(file_name, medium_name);
		},
		dragEnter(event) {
			this.hoverDropbox = true;
		},
		dragLeave(event) {
			this.hoverDropbox = false;
		},
		filesChange(fieldName, fileList) {
			this.uploadingStatus = 0;
			this.uploadingFileCount = fileList.length;

			// handle file changes
			if (!fileList.length) return;

			// append the files to FormData
			Array
				.from(Array(fileList.length).keys())
				.map(x => {
					let formData = new FormData();
					formData.append('file', fileList[x]);
					setTimeout(() => {
						this.uploadMedia({ id: this.item.id, media: formData })
							.then(() => {
								this.uploadingFileCount--;
								this.uploadingStatus += Math.round((100 / fileList.length));
							});
					}, 1000 * ((fileList.length - this.uploadingFileCount)));
				});
		},

		showDeleteModal(data) {
			if (this.isDeleting == false) {
				this.deletingKey = data.mediaKey;
				this.selectedDeleteMedia = data;
				this.$refs.deleteModal.show();
			}
		},

		deleteMediaItem(data) {
			this.deleteMedia(data).then(() => {
				if (!this.mediaError) {
					flashSuccess(this.$t('media.deleteSuccess'));
					this.$refs.deleteModal.hide();
				} else {
					flashDanger(this.$t('media.deleteError'));
				}
			});
		}
	},
	mounted() {

	},
}
</script>

<style lang="scss" scoped>
.media {
    &-item {
        &-image {
            background-size: cover;
            background-position: center center;
            height: 230px;
            width: 100%;
            position: relative;

            &-delete {
                display: none;
                height: 230px;
                width: 100%;
                background-color: rgba(255,0,0, .3);
                color: #fff;
                text-align: center;
                vertical-align: middle;
                line-height: 230px;
                border: none;
            }
            &:hover &-delete {
                display: block;
            }

            &-loader {
                height: 230px;
                width: 100%;
                background-color: rgba(255,0,0, .3);
                color: #fff;
                text-align: center;
                vertical-align: middle;
                line-height: 250px;
            }
        }
    }
}
.dropbox {
    outline: 2px dashed grey;
    /* the dash box */
    //outline-offset: -10px;
    //background: lightcyan;
    color: dimgray;
    margin: 0 2px;
    height: 200px;
    /* minimum height */
    position: relative;
    cursor: pointer;

    &.hovered {
        background-color: #f1f1f1;
    }

    .input-file {
        opacity: 0;
        /* invisible but it's there! */
        width: 100%;
        height: 200px;
        position: absolute;
        cursor: pointer;
    }

    &-info {
        margin: 0;
        padding: 0;
        font-size: 1.2em;
        text-align: center;
        padding-top: calc(100px - 1.5em);
    }
}
</style>



// WEBPACK FOOTER //
// ItemMedia.vue?a8641340